import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';
import colours from 'theme/atoms/colours';
import * as DropdownStyled from 'theme/components/Dropdown.style';
import * as SelectionStyled from 'theme/components/SelectionDropdown.style';
import { EntityTag } from 'shiftNotes/components/EntityTag/_index';
import { EntityTagColors } from 'shiftNotes/components/EntityTag/EntityTag';
import * as Styled from '../../styles/FilterGroupingControl.style';
import { TagOption } from './_types';

interface TagFilterMenuProps {
  tags: TagOption[];
  selected: string | null;
  onSelect: (id: string | null) => void;
  topOffset?: number;
}

const DEFAULT_TAG_COLORS: EntityTagColors = {
  bg: 'transparent',
  border: colours.neutral[200],
  text: colours.neutral[700],
};

const SELECTED_TAG_COLORS: EntityTagColors = {
  bg: 'transparent',
  border: colours.neutral[700],
  text: 'white',
};

export default function TagFilterMenu({
  tags,
  selected,
  onSelect,
  topOffset,
}: TagFilterMenuProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  return (
    <Styled.PopoverCard $zIndex={1400} $topOffset={topOffset} $leftOffset={-40}>
      <Styled.List>
        <DropdownStyled.SectionHeader>
          {t('filterGrouping.tags.title')}
        </DropdownStyled.SectionHeader>
        {tags.map((tag) => {
          const isSelected = selected === tag.id;
          return (
            <SelectionStyled.Option
              key={tag.id}
              type="button"
              $selected={isSelected}
              $compact
              onClick={() => onSelect(isSelected ? null : tag.id)}
              role="menuitemradio"
              aria-checked={isSelected}
            >
              <Styled.PillWrapper>
                <EntityTag
                  extractionClass={tag.id}
                  category={tag.name}
                  colors={isSelected ? SELECTED_TAG_COLORS : DEFAULT_TAG_COLORS}
                />
              </Styled.PillWrapper>
              <SelectionStyled.OptionCheck $selected={isSelected}>
                {isSelected && <General.Check size={16} />}
              </SelectionStyled.OptionCheck>
            </SelectionStyled.Option>
          );
        })}
      </Styled.List>
    </Styled.PopoverCard>
  );
}
